<template>
	<div class="signBody">
		<div class="signBody_content">
			<div class="signBody_content__right" v-if="needShow">
				<h3>欢迎参会</h3>
				<el-input style="margin-top: 50px;" v-model="input" placeholder="请输入您报名的手机号码"></el-input>
				<el-button style="margin-top: 50px;" type="primary" @click="applyMeeting">签到</el-button>
			</div>
			<el-result :icon="type" v-else title="消息提示" :subTitle="tips">
				<template slot="extra" v-if="type ==='success'">
					<el-descriptions title="" :column="1" border>
						<el-descriptions-item label-class-name="my-label"
							label="姓名">{{dataDetail.real_name}}</el-descriptions-item>
						<el-descriptions-item label-class-name="my-label"
							label="单位">{{dataDetail.company}}</el-descriptions-item>
					</el-descriptions>
				</template>
			</el-result>
		</div>
	</div>
</template>

<script>
	import {
		applyMeeting
	} from '@/api/moudles/activities.js'
	export default {
		data() {
			return {
				input: '',
				code: '',
				needShow: true,
				tips: '',
				type: 'success',
				rule: '',
				dataDetail: {}
			}
		},
		created() {
			const {
				code,
				rule
			} = this.$route.query
			this.code = code
			this.rule = rule
		},
		methods: {
			applyMeeting() {
				if (!this.input) {
					this.$message.error('请先输入手机号')
					return
				}
				if (!this.code) {
					this.$message.error('请使用正确的会议二维码')
					return
				}
				applyMeeting({
					data: {
						code: this.code,
						cellphone: this.input,
						rule:this.rule
					},
					success: res => {
						this.tips = res.msg
						this.needShow = false
						if (this.isTypeof(res.data) == 'array') {
							this.type = 'warning'
						} else {
							this.type = 'success'
							this.dataDetail = res.data
						}
					}
				})
			},
			isTypeof(o) {
				let s = Object.prototype.toString.call(o);
				return s.match(/\[object (.*?)\]/)[1].toLowerCase();
			}
		}
	}
</script>

<style scoped>
	>>>.my-label {
		font-weight: 600 !important;
	}

	@media screen and (max-width: 550px) {
		.signBody {
			min-height: 600px;
		}

		.signBody_content {
			display: flex;
			min-height: 400px;
			width: 100%;
			justify-content: center;
			/* align-items: center; */
		}

		.signBody_content__right {
			height: 100%;
			display: flex;
			margin: 20px;
			flex-flow: column;
			justify-content: center;
			align-items: center;
		}
	}

	@media screen and (min-width: 551px) {
		.signBody {
			min-height: calc(100vh - 300px);
			width: 1200px;
			margin: 20px auto;
			display: flex;
			flex-flow: column;
			justify-content: center;
			align-items: center;
		}

		.signBody_content {
			display: flex;
			min-height: 400px;
			width: 100%;
			justify-content: center;
			/* align-items: center; */
		}

		.signBody_content__right {
			height: 100%;
			display: flex;
			margin: 20px;
			flex-flow: column;
			justify-content: center;
			align-items: center;
		}
	}
</style>